import type { ServiceCategory, ServiceRecord, ServiceTabCategory, FleetRecord } from '../types'


export const serviceTabCategories: ServiceTabCategory[] = [
  'ski-transfers',
  'private-van-tours',
  'day-trips',
  'fleets',
]

export const serviceTabLabels: Record<ServiceTabCategory, string> = {
  'airport-transfers': 'Airport Transfers',
  'hotel-transfers': 'Hotel Transfers',
  'ski-transfers': 'Ski Transfers',
  'day-trips': 'Day Trips',
  'private-van-tours': 'Private Van Tours',
  'fleets': 'Fleets',
}

const route = 'Salzburg Airport (SZG) ↔ Salzburg City'

const dayTripDescription =
  "Explore Austria's most famous lakeside village surrounded by mountain"

const transferDescription =
  'Private airport transfers between Salzburg Airport and hotels, city centers, train stations, and nearby destinations.'

const badgeFor = (category: ServiceCategory): string => {
  if (category === 'day-trips') return 'Day TRip'
  if (category === 'private-van-tours' || category === 'multi-day-tour') return 'Tour'
  if (category === 'hourly-trips') return 'Trip'
  return 'Transfer'
}


export const services: ServiceRecord[] = [
  // Day Trips — matches the filtered grid in node 1826:44196.
  ...(
    [
      { id: 'day-fairytale-1', title: 'The Fairytale Village', priceEur: 120 },
      { id: 'day-ice-caves', title: 'Ice Caves Expedition', priceEur: 150 },
      { id: 'day-eagles-nest', title: "Eagle's Nest Historical Tour", priceEur: 95 },
      { id: 'day-sound-of-music', title: 'Sound of Music Tour', priceEur: 110 },
      { id: 'day-fairytale-2', title: 'The Fairytale Village', priceEur: 120 },
      { id: 'day-ice-caves-2', title: 'Ice Caves Expedition', priceEur: 150 },
      { id: 'day-eagles-nest-2', title: "Eagle's Nest Historical Tour", priceEur: 95 },
    ] as const
  ).map((item) => ({
    ...item,
    category: 'day-trips' as const,
    badge: badgeFor('day-trips'),
    route,
    description: dayTripDescription,
    active: true,
  })),
  {
    id: 'airport-express',
    title: 'Airport Express',
    category: 'airport-transfers',
    badge: badgeFor('airport-transfers'),
    route,
    description: transferDescription,
    priceEur: 85,
    active: true,
  },
  {
    id: 'hotel-shuttle',
    title: 'Hotel Shuttle',
    category: 'hotel-transfers',
    badge: badgeFor('hotel-transfers'),
    route: 'Salzburg City ↔ Hotel',
    description: transferDescription,
    priceEur: 65,
    active: true,
  },
  {
    id: 'ski-resort',
    title: 'Ski Resort Transfer',
    category: 'ski-transfers',
    badge: badgeFor('ski-transfers'),
    route: 'Salzburg ↔ Ski Amadé',
    description: transferDescription,
    priceEur: 140,
    active: true,
  },
  {
    id: 'van-alpine',
    title: 'Alpine Van Tour',
    category: 'private-van-tours',
    badge: badgeFor('private-van-tours'),
    route,
    description: transferDescription,
    priceEur: 220,
    active: true,
  },
]

/** Sentinel for the All tab; matches every category. */
export const ALL_SERVICES = 'all'

export type ServiceCategoryFilter = typeof ALL_SERVICES | ServiceTabCategory

export const filterServices = (
  records: ServiceRecord[],
  category: ServiceCategoryFilter,
) => {
  if (category === ALL_SERVICES) return records

  return records.filter((service) => service.category === category)
}

export const fleets: FleetRecord[] = [
  { id: 'f-1', category: 'Standard Saloon', categoryId: 1, brandId: 1, name: 'VW Passat', plate: 'S-CB 1624', image: '/assets/images/fleet-passat.png', passengers: 4, luggage: 3, description: 'Comfortable and reliable saloon, ideal for small groups and everyday airport or city transfers.', active: true },
  { id: 'f-2', category: 'Premium Saloon', categoryId: 2, brandId: 2, name: 'Mercedes E-Class', plate: 'S-CB 2841', image: '/assets/images/fleet-eclass.png', passengers: 4, luggage: 4, description: 'Refined and spacious premium saloon offering a smooth, comfortable ride for business and leisure travel.', active: true },
  { id: 'f-3', category: 'Economy Van', categoryId: 3, brandId: 3, name: 'Renault Trafic', plate: 'S-CB 3917', image: '/assets/images/fleet-trafic.png', passengers: 8, luggage: 8, description: 'Practical and spacious van designed for larger groups with plenty of luggage capacity.', active: true },
  { id: 'f-4', category: 'Premium Van', categoryId: 4, brandId: 2, name: 'Mercedes Vito', plate: 'S-CB 4672', image: '/assets/images/fleet-vito.png', passengers: 8, luggage: 8, description: 'Comfortable premium van offering generous space for passengers and luggage, perfect for group transfers.', active: true },
  { id: 'f-5', category: 'Business Van', categoryId: 5, brandId: 2, name: 'Mercedes V-Class', plate: 'S-CB 5289', image: '/assets/images/fleet-minibus.png', passengers: 7, luggage: 7, description: 'Elegant and luxurious van with a premium interior, ideal for VIP transfers and comfortable group travel.', active: true },
  { id: 'f-6', category: 'Minibus', categoryId: 6, brandId: 2, name: 'Mercedes Sprinter', plate: 'S-CB 6135', image: '/assets/images/fleet-sprinter-bus.png', passengers: 16, luggage: 16, description: 'Spacious and comfortable transport for up to 16 passengers.', active: true }
];
